var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:SALARIES_MONITORING",arg:"SALARIES_MONITORING"}]},[_c('h1',{staticStyle:{"text-align":"center","padding":"10px"}},[_vm._v("SALARY REPORTS")]),_c('all-salary-reports')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }